import React from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

const colorMap = {
  blue: "#066FEF",
  gray: "#333333",
  grey: "#333333",
};

const MotionPlus = ({ color = "blue", ...props }) => {
  const resolvedColor = colorMap[color] || color;
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 48 48"
      htmlColor={resolvedColor}
      shapeRendering="crispEdges"
    >
      <path d="M37.2 22.8H25.2V10.8H22.8V22.8H10.8V25.2H22.8V37.2H25.2V25.2H37.2V22.8Z" />
    </SvgIcon>
  );
};

MotionPlus.propTypes = {
  color: PropTypes.string,
};

export default MotionPlus;
